import { gql } from '@apollo/client';

import { StudentPracticeSessionsActivity } from '@ts-core/modules/billing/types';

export interface GetStudentPracticeSessionsByMonthQueryVariables {
  courseId: string;
  studentId: string;
  year: string;
  month: string;
}

export interface GetStudentPracticeSessionsByMonthQueryResult {
  practiceSessions: StudentPracticeSessionsActivity[];
}

export const getStudentPracticeSessionsByMonthQuery = gql`
  query GetStudentPracticeSessionsByMonthQuery($courseId: String!, $studentId: String!, $year: String!, $month: String!) {
    practiceSessions(courseId: $courseId, studentId: $studentId, year: $year, month: $month)
      @rest(
        type: "StudentPracticeSessionsActivityByMonth"
        path: "students-activity/years/{args.year}/months/{args.month}/courses/{args.courseId}/students/{args.studentId}/practice-sessions"
      ) {
      _id
      name
      createdAt
      score
    }
  }
`;
